<template>
  <b-card no-body>
    <div v-if="loading">
      <b-card-header class="py-1">
        <b-card-title  > میزان مشارکت </b-card-title>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="6">
            <b-skeleton class="my-1 py-1" />
            <b-skeleton class="my-1 py-1" />
          </b-col>
          <b-col cols="6">
            <b-skeleton height="102px" width="120" class="mb-0" />
          </b-col>
        </b-row>
      </b-card-body>
    </div>
    <div v-else>
      <b-card-header class="py-1">
        <b-card-title  > میزان مشارکت </b-card-title>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col lg="6" cols="12">
            <h5
              class="mb-1"
              v-if="earning.total && earning.total.TotalParticipated"
            >
              تعداد کل کاربران : {{ earning.total.TotalParticipated }}
            </h5>
            <b-card-text class="text-muted font-small-2">
              <span class="font-weight-bolder">
                نسبت مشارکت کاربران در دوره ها</span
              >
            </b-card-text>
          </b-col>
          <b-col lg="6" cols="12">
            <vue-apex-charts
              v-if="Object.keys(earningsChart).length"
              height="102"
              :options="earningsChart.chartOptions"
              :series="[earning.total.count, 100 - earning.total.count]"
            />
          </b-col>
        </b-row>
      </b-card-body>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BCardTitle,
  BCardText,
  BSkeleton,
  BCardBody,
  BCardHeader,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";

const $earningsStrokeColor2 = "#28c76f66";
const $earningsStrokeColor3 = "#28c76f33";
export default {
  components: {
    BCardBody,
    BCardHeader,
    BCard,
    BRow,
    BCol,
    BCardTitle,
    BCardText,
    VueApexCharts,
    BSkeleton,
  },
  props: {
    earning: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  watch: {
    loading: {
      handler(val) {
        if (!val) {
          let count = this.earning.total.count;
          this.earningsChart = {
            chartOptions: {
              chart: {
                type: "donut",
                toolbar: {
                  show: false,
                },
              },
              dataLabels: {
                enabled: false,
              },
              legend: { show: false },
              labels: ["مشارکت", "عدم مشارکت"],
              colors: [$earningsStrokeColor2, $earningsStrokeColor3],
              grid: {
                padding: {
                  right: -20,
                  bottom: -8,
                  left: -20,
                },
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        offsetY: 15,
                      },
                      value: {
                        offsetY: -15,
                        formatter(val) {
                          // eslint-disable-next-line radix
                          return `${parseInt(val)}%`;
                        },
                      },
                      total: {
                        show: true,
                        offsetY: 15,
                        label: "",
                        formatter() {
                          return `${count}%`;
                        },
                      },
                    },
                  },
                },
              },
            },
          };
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      earningsChart: {},
    };
  },
};
</script>
